<a *ngIf="item"
  class="link-row {{ item.class }}"
  [attr.href]="item.href"
  [attr.data-test]="item.testAttribute"
  [trackClickData]="item.trackClickData"
  target="_self"
  mat-menu-item
  modeTrackClick
  (click)="clicked.emit($event)"
>
  <capra-icon [icon]="item.icon"></capra-icon>
  <div class="menu-text">
    <span class="menu-item-title" data-test="menu-item-title">{{ item.title }}</span>
    <span class="menu-item-subtitle" data-test="menu-item-subtitle">{{ item.subtitle }}</span>
  </div>
</a>
